import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { AdministrationState } from './types'

const initialState: AdministrationState = {
  openCreateManagerMenu: false,
  openRemoveManagerMenu: false,
  openUpdateManagerMenu: false,
  openResentInvitationMenu: { isOpen: false, email: '' },
  setUpdateManagerContent: false,
  openCreateUnitsDialog: false,
  openUnitsSuccessDialog: false,
  openRemoveUnitDialog: { isOpen: false, unit: null },
}

export const administrationSlice = createSlice({
  name: 'administrationSlice',
  initialState,
  reducers: {
    openCreateManagerMenu(state, action) {
      state.openCreateManagerMenu = action.payload
    },
    openUpdateManagerMenu(state, action) {
      state.openUpdateManagerMenu = action.payload
    },
    setUpdateManagerContent(state, action) {
      state.setUpdateManagerContent = action.payload
    },
    openRemoveManagerMenu(state, action) {
      state.openRemoveManagerMenu = action.payload
    },
    setNotifications(state, action) {
      state.setNotifications = action.payload
    },
    openResentInvitationMenu(state, action) {
      state.openResentInvitationMenu = action.payload
    },
    openCreateUnitsDialog(state, action) {
      state.openCreateUnitsDialog = action.payload
    },
    setOpenUnitsSuccessDialog(state, action) {
      state.openUnitsSuccessDialog = action.payload
    },
    setOpenRemoveUnitDialog(state, action) {
      state.openRemoveUnitDialog = action.payload
    },
    closeRemoveUnitDialog(state) {
      state.openRemoveUnitDialog = { isOpen: false, unit: null }
    },
  },
})

export const administrationReducer = persistReducer(
  {
    key: 'rtk:tenant',
    storage,
    whitelist: [''],
  },
  administrationSlice.reducer,
)
